import { c as _c } from "react/compiler-runtime";
import { twJoin } from 'tailwind-merge';
import { ArrowDownSmoothIcon } from '@systemeio/ui/icons';
import { SortDirectionEnum } from '../enums';
interface TableSortElementProps {
  sortOrder: SortDirectionEnum | undefined;
  onSortOrderChange?: () => void;
  className?: string;
}
export function TableSortElement(t0) {
  const $ = _c(13);
  const {
    sortOrder,
    onSortOrderChange,
    className
  } = t0;
  let t1;
  bb0: switch (sortOrder) {
    case SortDirectionEnum.Asc:
      {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <ArrowDownSmoothIcon width={10} height={6} className="mb-1" />;
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        t1 = t2;
        break bb0;
      }
    case SortDirectionEnum.Desc:
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <ArrowDownSmoothIcon width={10} height={6} className="rotate-180" />;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        t1 = t2;
        break bb0;
      }
    default:
      {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <div className="flex flex-col gap-[1px]"><ArrowDownSmoothIcon width={10} height={6} className="fill-text-secondary" /><ArrowDownSmoothIcon width={10} height={6} className="fill-text-secondary rotate-180" /></div>;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
      }
  }
  const sortIcon = t1;
  let t2;
  if ($[3] !== onSortOrderChange) {
    t2 = e => {
      e.stopPropagation();
      onSortOrderChange?.();
    };
    $[3] = onSortOrderChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className) {
    t3 = twJoin("flex items-center", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== sortIcon) {
    t4 = <span>{sortIcon}</span>;
    $[7] = sortIcon;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <button type="button" onClick={t2} className={t3}>{t4}</button>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}